import Component from '@glimmer/component';
import urlBuilder from 'garaje/utils/url-builder';

/**
 * @param {string} companyId  Required. The company config
 */
export default class Warning extends Component {
  googleAuthUrl = urlBuilder.roomba.googleAuthUrl();
}
